export function normalizePath(filePath: any) {
  return filePath.replace(/\\/g, '/')
}
